var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocketsLockL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    transform: "rotate(90 16 16)",
    fill: "#171F36",
    stroke: "#FFF399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2001 7C12.4386 7 10.2001 9.23858 10.2001 12V12.9623C8.895 13.621 8 14.9737 8 16.5354V19.1181C8 21.3272 9.79086 23.1181 12 23.1181H20C22.2091 23.1181 24 21.3272 24 19.1181V16.5354C24 14.9737 23.1051 13.6211 21.8001 12.9624V12C21.8001 9.23858 19.5615 7 16.8001 7H15.2001ZM19.8001 12.5354V12C19.8001 10.3431 18.4569 9 16.8001 9H15.2001C13.5432 9 12.2001 10.3431 12.2001 12V12.5354H19.8001Z",
    fill: "#C2C4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 19.69V21H14.6V13.99H16.08V19.69H18.8Z",
    fill: "#304477"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketsLockL);
export default __webpack_public_path__ + "static/media/sockets-lock-l.363ab337465f8a7c68f9be80a18b6736.svg";
export { ForwardRef as ReactComponent };